import GlobeImg from "../../../assets/icons/globe.png";
import LocationImg from "../../../assets/icons/location.png";
import Successful_Student from "../../../assets/icons/Successful_Student.png";

import { ProductOption } from "../types";

export const PRODUCTS: ProductOption[] = [
  {
    value: "study_abroad",
    label: "I want to study abroad",
    icon: GlobeImg,
    description:
      "For students planning to study at top universities abroad with global coverage.",
    badge: null,
  },
  {
    value: "study_india",
    label: "I want to study in India",
    icon: LocationImg,
    description:
      "Financial support for prestigious institutions and courses within the country.",
    badge: null,
  },
];

export const testomonials = [
  {
    rating: 5,
    text: "I would recommend that every student go for Avanse Financial Services education loan. Great work, easy process, Quick disbursement.",
    studentName: "Shruti Shyamal Sarkar",
    studentDetails: "Master of Cyber Security, Griffith University, Australia",
    studentImage: Successful_Student,
  },
  {
    rating: 4,
    text: "Exceptional work from the Avanse Financial Services team regarding the loan application; it was a swift process. Everything was transparent and super easy",
    studentName: "Vansh Singh",
    studentDetails: "Masters in Data Science, University of Bath, UK",
    studentImage: Successful_Student,
  },
  {
    rating: 4,
    text: "The assigned agent was excellent in their work and very sharp, knowing how to handle things and being a valuable asset for Avanse Financial Services.",
    studentName: "Paras Jha",
    studentDetails:
      "MSc Data Science and Analytics, Brunel University London, UK",
    studentImage: Successful_Student,
  },
  {
    rating: 5,
    text: "The loan process was very seamless and stress-free.",
    studentName: "Srinivas Moukthik Miriyal",
    studentDetails:
      "Master Of Science In Regulatory Affairs For Drugs, Biologics & Medical Devices - General Regulatory Affairs, Northeastern University, Canada",
    studentImage: Successful_Student,
  },
  {
    rating: 4,
    text: "Transparent loan process and very quick response from the employee",
    studentName: "Sima Nazarali Vadsariya",
    studentDetails:
      "MSC Public Health and Social Care in Practice, The University of Wales Trinity Saint David, UK",
    studentImage: Successful_Student,
  },
  {
    rating: 5,
    text: "Avanse Financial Services team is very professional and always helps with every query",
    studentName: "Swati Dhiman",
    studentDetails:
      "MBA, IU International University of Applied Sciences, Germany",
    studentImage: Successful_Student,
  },
  {
    rating: 5,
    text: "Easy process and very helpful staff",
    studentName: "Disha Gajanan Tandel",
    studentDetails: "Master of Finance, RMIT University, Australia",
    studentImage: Successful_Student,
  },
  {
    rating: 5,
    text: "Avanse Financial Services was very helpful for students, and the loan process was easy.",
    studentName: "Sanjay Nimma",
    studentDetails:
      "MBA with Professional Experience, York ST John University, England",
    studentImage: Successful_Student,
  },
  {
    rating: 4,
    text: "Avanse Financial Services is a good choice for students looking for Education loans as it provides disbursements on time",
    studentName: "Saikalpana Gogineni",
    studentDetails: "MSc Computer Science, Coventry University, UK",
    studentImage: Successful_Student,
  },
  {
    rating: 4,
    text: "The sales representative was very supportive, and their patience was greatly appreciated. Thanks to the team for providing this loan.",
    studentName: "Lakshmi Tumu",
    studentDetails:
      "MSc Healthcare Leadership (with Professional Development and Planning (PDP), BPP UNIVERSITY",
    studentImage: Successful_Student,
  },
];
